
import { defineComponent } from 'vue';
import TypeItem from '@components/activity/TypeItem.vue';

export default defineComponent({
  name: 'TypeText',
  props: ['communityList'],
  emits: ['jumpFanPage', 'getGift'],
  setup(_props: any, { emit }) {
    const jumpFanPage = (plat) => {
      emit('jumpFanPage', plat);
    };
    const getGift = (plat) => {
      emit('getGift', plat);
    };
    return {
      jumpFanPage,
      getGift,
    };
  },
  components: {
    TypeItem,
  },
});
